export default "__VITE_ASSET__CEucPezl__"